import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { ShortcutService } from '../shortcut.service';

@Component({
  selector: 'app-canvas-window',
  templateUrl: './canvas-window.component.html',
  styleUrls: ['./canvas-window.component.scss']
})
export class CanvasWindowComponent implements OnInit {

  /** @var {ElementRef} canvas['nativeElement'] grants referenece to the HTMLElement of this component's container */
  @ViewChild("canvas", {static: false, read: ElementRef }) canvas: ElementRef;
  /** @var 2D context of canvas */
  private context: any;
  /** @var Is canvas active */
  public active: boolean;
  public mouseDown: boolean;
  public visibility: boolean;
  private penSize: number;
  private penColor: string;
  private strokeX: number[];
  private strokeY: number[];
  private strokeColor: string[];
  private strokeSize: number[];
  private drag: boolean[];
  private ctrlKey: boolean = false;

  constructor(
    private shortcutService: ShortcutService
  ) { }

  ngOnInit() {
    this.strokeX = new Array();
    this.strokeY = new Array();
    this.strokeColor = new Array();
    this.strokeSize = new Array();
    this.drag = new Array();
    this.mouseDown = false;
  }

  ngAfterViewInit() {
    this.context = this.canvas['nativeElement'].getContext("2d");
    this.penSize = 5;
  }

  onMouseDown($e) {
    this.mouseDown = true;
    this.addStroke($e.pageX-$e.target.getBoundingClientRect().left, $e.pageY-$e.target.getBoundingClientRect().top, false);
    this.draw();
  }

  onMouseUp($e) {
    this.mouseDown = false;
  }
  
  onMouseMove($e) {
    this.addStroke($e.pageX-$e.target.getBoundingClientRect().left, $e.pageY-$e.target.getBoundingClientRect().top, true);
    this.draw();
  }

  draw() {
    this.context.clearRect(0, 0, 1700, 860);
    this.context.lineJoin = "round";
    for (var i = 0; i < this.strokeX.length; i++) {
      this.context.beginPath();
      if (this.drag[i] && i) {
        this.context.moveTo(this.strokeX[i-1], this.strokeY[i-1]);
      }
      else {
        this.context.moveTo(this.strokeX[i]-1, this.strokeY[i]);
      }
      this.context.lineTo(this.strokeX[i], this.strokeY[i]);
      this.context.closePath();
      this.context.strokeStyle = this.strokeColor[i];
      this.context.lineWidth = this.strokeSize[i];
      if (this.strokeColor[i] === "n")
        this.context.globalCompositeOperation = "destination-out";
      else {
        this.context.globalCompositeOperation = "source-over";
      }
      this.context.stroke();
    }
  }

  addStroke(x, y, drag) {
    this.strokeX.push(x);
    this.strokeY.push(y);
    this.strokeColor.push(this.penColor);
    this.strokeSize.push(this.penSize);
    this.drag.push(drag);
  }

  removeStroke(index) {
    this.strokeX.splice(index, 1);
    this.strokeY.splice(index, 1);
    this.strokeColor.splice(index, 1);
    this.strokeSize.splice(index, 1);
    this.drag.splice(index, 1);
  }

  undo() {
    for (let i = this.drag.length-1; i > -1; i--) {
      this.removeStroke(i);
      if (!this.drag[i-1]) {
        this.removeStroke(i-1);
        break;
      }
    }
    this.draw();
  }

  setColor($event) {
    this.penColor = $event;
  }

  setSize($event) {
    this.penSize = $event.value;
  }

  setVisibility($event) {
    this.visibility = $event;
    if (this.visibility)
      this.canvas['nativeElement'].style.display="block";
    else
      this.canvas['nativeElement'].style.display="none";
  }

  clear($event) {
    this.strokeX = [];
    this.strokeY = [];
    this.strokeColor = [];
    this.strokeSize = [];
    this.drag = [];
    this.context.clearRect(0, 0, 1700, 860);
  }

  exit($event) {
    this.active = !$event;
  }

  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.shortcutService.enabled) {
      if (event.keyCode === 90 && this.ctrlKey && this.active) {
        this.undo();
      }
      else if (event.keyCode === 17) {
        this.ctrlKey = true;
      }
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyReleaseEvent(event: KeyboardEvent) {
    if (this.shortcutService.enabled) {
      if (event.keyCode === 17) {
        this.ctrlKey = false;
      }
    }
  }

}
